import React, { useEffect, useState } from "react";
import axios from "axios";
import ListDataOrganisasiDataCompOpenData from "../../../components/open_data/organisasi/ListDataOrganisasiDataCompOpenData";
import SearchOrganisasiDataCompOpenData from "../../../components/open_data/organisasi/SearchOrganisasiDataCompOpenData";
import "../../../config";

// Tambahkan fungsi formatDate yang aman
const safeFormatDate = (dateString) => {
    if (!dateString) return "2025-04-25";
    try {
        return dateString.split('T')[0];
    } catch (e) {
        return "-";
    }
};

const ListDataOrganisasiDataOpenData = () => {
    const [data_x, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const itemsPerPage = 12;

    const api1Url = global.config.host + '/api/3/action/organization_list';
    const api2Url = global.config.host + '/api/3/action/organization_show?id=';
    const apiBpsUrl = 'https://webapi.bps.go.id/v1/api/domain/type/kab/prov/kabprov/key/2a5fc573c8b3c000270a925dd7d8f334/';
    const api2BpsUrl = 'https://webapi.bps.go.id/v1/api/list/model/statictable/lang/ind/domain/3527/key/2a5fc573c8b3c000270a925dd7d8f334/';

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // Fetch data API CKAN
                const response1 = await axios.get(api1Url);
                const ids = response1.data.result;

                const api2Requests = ids.map(id => axios.get(`${api2Url}${id}`));
                const api2Responses = await Promise.all(api2Requests);
                const api2Data = api2Responses.map(res => res.data.result);

                // Fetch data API BPS (untuk metadata)
                const responseBps = await axios.get(apiBpsUrl);
                
                // Fetch BPS table data untuk mendapatkan jumlah total data
                const bpsTables = await axios.get(api2BpsUrl);
                
                // Ekstrak total dari respons API sesuai dengan struktur yang diberikan
                let bpsDataCount = 0;
                if (bpsTables.data && 
                    bpsTables.data.data && 
                    bpsTables.data.data[0] && 
                    bpsTables.data.data[0].total) {
                    bpsDataCount = bpsTables.data.data[0].total;
                }
                //console.log("BPS data count:", bpsDataCount);

                // Create the BPS organization object with count
                const bpsOrg = {
                    display_name: "BPS",
                    title: "BPS",
                    domain_name: "Sampang",
                    data_type: 'bps',
                    // Add count from BPS tables API
                    package_count: bpsDataCount,
                    created_date: new Date().toISOString(),
                    last_modified: new Date().toISOString(),
                    description: "Badan Pusat Statistik"
                };

                // Penggabungan API CKAN dan API BPS
                const combineData = [...api2Data, bpsOrg]
                .filter(item => item)
                .map(item => ({
                    ...item,
                    title: item.title || item.display_name,
                    created_date: item.created_date || new Date().toISOString(),
                    // Tambahkan field lain yang mungkin diakses
                    last_modified: item.last_modified || new Date().toISOString(),
                    // Make sure package_count is always available
                    package_count: item.package_count || 0
                }));

                setData(combineData);
                setFilteredData(combineData);
                setTotalItems(combineData.length);
            } catch (error) {
                console.error('Error fetching data', error);
                setData([]);
                setFilteredData([]);
                setTotalItems(0);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        // Filter data setiap kali searchQuery berubah
        filterData();
    }, [searchQuery, data_x]);

    const filterData = () => {
        let filtered = data_x;

        if (searchQuery) {
            filtered = data_x.filter(item =>
                item.title.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        setFilteredData(filtered);
        setTotalItems(filtered.length); // Update total items to filtered data length
    };

    const handleSearch = (query) => {
        setSearchQuery(query);
        setCurrentPage(1); // Reset halaman ke 1 saat pencarian berubah
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const startItem = indexOfFirstItem + 1;
    const endItem = Math.min(indexOfLastItem, totalItems);

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    return (
        <div>
            <SearchOrganisasiDataCompOpenData onSearch={handleSearch} />
            <ListDataOrganisasiDataCompOpenData
                items={filteredData.map(item => ({
                    ...item,
                    title: item.title,
                    created_date: item.created_date || new Date().toISOString(),
                    last_modified: item.last_modified || new Date().toISOString(),
                    description: item.description || "",
                    // Make sure package_count is always available for display
                    package_count: item.package_count || 0,
                    // tambahkan semua field yang mungkin diakses
                }))}
                /* items={currentData} */
                // currentPage={currentPage}
                totalItems={totalItems}
                /*itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange} */
                formatDate={safeFormatDate}
                /* startItem={startItem}
                endItem={endItem} */
                loading={loading}
            // totalPages={totalPages}
            />
        </div>
    );
};

export default ListDataOrganisasiDataOpenData;